import { Box } from '@skin-seoul/design-system';
import React from 'react';
import { LucideIcon } from '../../components';
interface CheckIconProps {
  achieved: boolean;
}
export function CheckIcon({
  achieved
}: CheckIconProps) {
  return <Box width="24px" height="24px" bg={achieved ? 'success.600' : 'neutral.600'} display="flex" alignItems="center" borderRadius="12px" justifyContent="center" data-sentry-element="Box" data-sentry-component="CheckIcon" data-sentry-source-file="CheckIcon.tsx">
      <LucideIcon name="Check" strokeWidth={2.4} color="generic.0" boxSize={4} data-sentry-element="LucideIcon" data-sentry-source-file="CheckIcon.tsx" />
    </Box>;
}